<input type="checkbox" [hidden]="!showCheckBoxWithText" (click)="onClick($event)"> <span
    [hidden]="!text">{{text}}</span>